<template>
  <div class="text-center flex flex-col items-center">
    <HeaderH1>Get in touch</HeaderH1>
    <p class="mt-3 max-w-2xl text-lg text-muted">
      You are welcome to contact us on any topic. We usually respond within one
      week.
    </p>
    <p class="mt-3 text-lg text-muted">
      If you have any feedback, please submit it
      <NuxtLink to="/give-feedback" class="underline">here</NuxtLink>, so we can
      improve.
    </p>
    <UCard variant="subtle" class="mt-9 max-w-lg w-full">
      <div class="mt-9">
        <FormLabel required :value="name">Name</FormLabel>
        <UInput v-model="name" class="w-full" size="xl" />
      </div>
      <div class="mt-3">
        <FormLabel
          :value="email"
          :is-valid="(v) => isValidEmail(v as string)"
          required
          >Email</FormLabel
        >
        <UInput v-model="email" class="w-full" size="xl" />
      </div>
      <div class="mt-3">
        <FormLabel required :value="msg">Your message</FormLabel>
        <UTextarea v-model="msg" size="xl" :rows="8" class="w-full" />
        <div v-if="error" class="text-left text-error-500 mt-6">
          {{ error }}
        </div>
      </div>
      <template #footer>
        <div class="text-left">
          <UButton
            class="cursor-pointer"
            size="xl"
            :loading="loading"
            :disabled="!readyToSubmit"
            @click="sendMessage"
            >Send message</UButton
          >
        </div>
      </template>
    </UCard>
  </div>
</template>

<script setup lang="ts">
import { isValidEmail } from "~~/shared/utils/validate";

const name = ref("");
const email = ref("");
const msg = ref("");
const error = ref("");
const toast = useToast();
const loading = ref(false);

const readyToSubmit = computed<boolean>(() => {
  if (name.value.length < 3) return false;
  if (!isValidEmail(email.value)) return false;
  if (msg.value.length < 4) return false;
  return true;
});

function reset() {
  name.value = "";
  email.value = "";
  msg.value = "";
  error.value = "";
  loading.value = false;
}

async function sendMessage() {
  loading.value = true;
  error.value = "";
  await $fetch("/api/message-admins", {
    method: "POST",
    body: {
      name: name.value,
      msg: msg.value,
      email: email.value,
    },
    onResponse: (ctx) => {
      if (ctx.response.status === 204) {
        toast.add({
          icon: "i-mdi-check",
          color: "success",
          title: "Your message was sent",
          description: "We will answer you as soon as possible.",
        });
        reset();
      }
    },
    onResponseError: async (ctx) => {
      const msg = await parseApiError(
        ctx.error || ctx.response._data || ctx.response,
      );
      loading.value = false;
      error.value = msg;
    },
  });
}
</script>
